import { AnimatePresence } from "motion/react";
import ServiceLocator from "../../../../../domain/service-locator";
import { GeneralAudioPlayerComponent } from "../../components/player/general-audio-player-component";

export const GeneralAudioPlayerContainer = () => {
  const currentTrack = ServiceLocator.GuidePlayerModule.currentTrack.watch();
  return (
    <AnimatePresence>
      {currentTrack && (
        <>
          <GeneralAudioPlayerComponent />
        </>
      )}
    </AnimatePresence>
  );
};
